import {Injectable} from '@angular/core';
import {User} from '../../types/security/user';
import {Observable, of} from 'rxjs';
import {SecurityRestService} from './security-rest.service';


import {Locale} from '../../types/localization/locale';
import {map} from 'rxjs/operators';

@Injectable()
export class SecurityService {

  private user: User = null;

  private permissions: string[] = [];

  constructor(private securityRestService: SecurityRestService) {}

  isAuthenticated(): Observable<boolean> {
    return this.getLoggedUser().pipe(map(
      (user: User) => {
        return user != null && user.id != null;
      }
    ));
  }

  getLoggedUser(refresh: boolean = false): Observable<User> {
    if (this.user && !refresh) {
      return of(this.user);
    }
    return this.securityRestService.getCurrentUser().pipe(map(
      (user: User) => {
        this.user = user;
        return this.user;
      },
      (rsp: any) => {
        this.user = null;
        return null;
      }
    ));
  }

  getCurrentLocale(): Observable<Locale> {
    return this.getLoggedUser().pipe(map(
      (user: User) => user.locale
    ));
  }

  hasPermission(permission: string): Observable<boolean> {
    if (this.permissions.length > 0) {
      return of(this.permissions.includes(permission));
    }
    return this.securityRestService.getUserPermissions().pipe(map(
      (permissions: string[]) => {
        this.permissions = permissions;
        return this.permissions.includes(permission);
      },
      (rsp: any) => {
        return false;
      }
    ));
  }

  getPermissions(): Observable<string[]> {
    if (this.permissions.length > 0) {
      return of(this.permissions);
    }
    return this.securityRestService.getUserPermissions();
  }

  hasAnyPermission(checkedPermissions: string[]): Observable<boolean> {
    if (this.permissions.length > 0) {
      return of(this.contains(this.permissions, checkedPermissions));
    }
    return this.securityRestService.getUserPermissions().pipe(map(
      (permissions: string[]) => {
        this.permissions = permissions;
        return this.contains(this.permissions, checkedPermissions);
      },
      (rsp: any) => {
        return false;
      }
    ));
  }

  private contains(userPermission: string[], checkedPermissions: string[]): boolean {
    return checkedPermissions.some(function(permission) {
      return userPermission.includes(permission);
    });
  }

  refreshPermission() {
    this.securityRestService.getUserPermissions().subscribe(
      (permissions: string[]) => {
        this.permissions = permissions;
      }
    );
  }

}
